import LegacySidePanel from './LegacySidePanel';
export default LegacySidePanel;
